module.exports = __webpack_public_path__ + "images/other_vehicle.10673b4bf7a06f1e2e79d579e76582db.png";